import {Credentials, Email, Hmac, UpdateUser, ResetPassword, Token} from '../../Config/dataModel';
import {authRequest, request} from './request';

const login = (credentials: Credentials) => {
    return request({
        url: '/login',
        method: 'POST',
        data: credentials
    });
};

const logout = () => {
    return authRequest({
        url: '/logout',
        method: 'POST'
    });
};

const forgotPassword = (data: Email) => {
    return request({
        url: '/forgot',
        method: 'POST',
        params: data
    });
};

const resetPassword = (data: ResetPassword) => {
    return request({
        url: '/reset',
        method: 'POST',
		data
    });
};

const updateUser = (data: UpdateUser) => {
    return authRequest({
        url: '/userInfo/updateCurrentUserInfo',
        method: 'PUT',
        data
    });
};

const validateIdentityNo = (hmac: Hmac) => {
    return authRequest({
        url: '/hmac/check',
        method: 'PUT',
        data: hmac
    });
};

const resetSecret = (data: Token) => {
    return request({
        url: '/resetSecret',
        method: 'POST',
        data
    });
};


const authAPI = {login, logout, updateUser, forgotPassword, resetPassword, validateIdentityNo, resetSecret};

export default authAPI



// WEBPACK FOOTER //
// ./src/ReduxRequests/APIs/authAPI.ts